<template>
  <div class="area-candidato">
    <div v-if="profile.id">
      <!-- Header da Área do Candidato -->
      <header class="area-header">
        <div class="container">
          <div class="header-content">
            <div class="header-brand">
              <img src="@/assets/images/logo.png" alt="Logo" class="header-logo" />
              <div class="brand-info">
                <h1 class="brand-title">Área do Candidato</h1>
                <p class="brand-subtitle">Portal de Concursos Públicos</p>
              </div>
            </div>
            
            <div class="header-user">
              <div class="user-info">
                <div class="user-avatar">
                  <i class="fas fa-user"></i>
                </div>
                <div class="user-details">
                  <h6 class="user-name">{{ profile.nome || profile.nomeCandidato }}</h6>
                  <span class="user-status">Candidato Ativo</span>
                </div>
              </div>
              <button class="btn btn-outline-danger btn-logout" @click="logOut">
                <i class="fas fa-sign-out-alt me-1"></i>Sair
              </button>
            </div>
          </div>
        </div>
      </header>

      <!-- Navigation -->
      <nav class="area-navbar">
        <div class="container">
          <div class="navbar-content">
            <!-- Mobile Toggle -->
        <button
              class="navbar-toggle"
          type="button"
          @click="toggleNavbar"
          :aria-expanded="isNavbarOpen"
          aria-label="Toggle navigation"
        >
              <span class="toggle-line"></span>
              <span class="toggle-line"></span>
              <span class="toggle-line"></span>
        </button>

            <!-- Overlay para mobile -->
            <div 
              v-if="isNavbarOpen" 
              class="navbar-overlay" 
              @click="closeNavbarOnMobile"
            ></div>

            <!-- Navigation Menu -->
            <div class="navbar-menu" :class="{ 'is-open': isNavbarOpen }">
              <ul class="nav-list">
            <li
              v-for="item in menu"
              :key="item.name"
              class="nav-item"
                  :class="{ 'has-submenu': item.submenu }"
            >
              <template v-if="item.submenu">
                <!-- Menu com submenu -->
                    <button
                      class="nav-link nav-link-dropdown"
                      @click="toggleSubMenu(item.name)"
                  :aria-expanded="isSubMenuOpen(item.name)"
                >
                      <i :class="item.icon" class="nav-icon"></i>
                      <span class="nav-text">{{ item.title }}</span>
                      <i class="fas fa-chevron-down nav-arrow"></i>
                    </button>
                <ul
                  v-if="isSubMenuOpen(item.name)"
                  class="submenu"
                >
                  <li
                    v-for="subItem in item.submenu"
                    :key="subItem.name"
                    class="submenu-item"
                  >
                    <router-link
                      class="submenu-link"
                      :to="{ name: subItem.name }"
                      @click.native="closeNavbarOnMobile"
                    >
                          <i :class="subItem.icon" class="submenu-icon"></i>
                      {{ subItem.title }}
                    </router-link>
                  </li>
                </ul>
              </template>
              <template v-else>
                <!-- Menu sem submenu -->
                <router-link
                      :class="['nav-link', isCurrent(item.name) ? 'active' : '']"
                  :to="{ name: item.name }"
                      @click.native="closeNavbarOnMobile"
                >
                      <i :class="item.icon" class="nav-icon"></i>
                      <span class="nav-text">{{ item.title }}</span>
                      <span v-if="item.badge" class="nav-badge">{{ item.badge }}</span>
                </router-link>
              </template>
            </li>
          </ul>
            </div>
          </div>
        </div>
      </nav>

      <!-- Main Content -->
      <main class="area-main">
        <div class="container">
          <!-- Router View Content -->
          <div class="content-section">
        <router-view />
      </div>
        </div>
      </main>

      <!-- Support Section -->
      <section class="support-section">
        <div class="container">
          <div class="support-content">
            <div class="support-icon">
              <i class="fas fa-question-circle"></i>
            </div>
            <div class="support-text">
              <h5>Precisa de Ajuda?</h5>
              <p>
                Se tiver alguma dúvida ou problema com sua inscrição, entre em contato conosco:
                <a :href="`mailto:${suporte}`" class="support-email">{{ suporte }}</a>
          </p>
        </div>
      </div>
        </div>
      </section>

      <Footer />
    </div>
    <div v-else class="d-flex justify-content-center align-items-center vh-100">
      <img src="@/assets/images/loading.gif" class="img-fluid" style="max-width: 100px; max-height: 100px;" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Footer from '@/components/Footer';
import Informacoes from '@/components/Informacoes';

export default {
  components: {
    Footer,
    Informacoes,
  },

  data() {
    return {
      suporte: 'suporte@ibcgp.org.br',
      openSubMenus: {},
      isNavbarOpen: false, // Estado para controlar a abertura/fechamento do menu
    };
  },

  async created() {
    const token = localStorage.getItem(`token-${this.$city}`);
    if (!token) {
      this.logOut();
      return;
    }

    axios.defaults.headers['Authorization'] = `Bearer ${token}`;

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const response =
          error?.response?.message ||
          error?.response?.data?.message ||
          error?.response?.data ||
          error?.response;
        if (response === 'Token has expired') this.logOut();
        return Promise.reject(error);
      }
    );

    try {
      const { data, status } = await axios.get('/ps/candidato/dados');

      // console.log('Dados recebidos do candidato:', data, 'Status:', status);

      if (status > 299) {
        // console.log('Status > 299, redirecionando para home');
        this.$router.push({ name: 'home' }).catch((e) => e);
        return;
      }

      // Verificar estrutura dos dados retornados
      // console.log('Estrutura dos dados:', JSON.stringify(data, null, 2));

      let cadastroData = null;

      // Tentar diferentes estruturas possíveis
      if (data && data.length > 0) {
        if (data[0] && data[0].length > 0) {
          if (data[0][0] && data[0][0].cadastro) {
            // Estrutura: [[{cadastro: {...}}]]
            cadastroData = data[0][0].cadastro;
          } else if (data[0][0]) {
            // Estrutura: [[{...}]]
            cadastroData = data[0][0];
          }
        } else if (data[0] && data[0].cadastro) {
          // Estrutura: [{cadastro: {...}}]
          cadastroData = data[0].cadastro;
        } else if (data[0]) {
          // Estrutura: [{...}]
          cadastroData = data[0];
        }
      } else if (data && data.cadastro) {
        // Estrutura: {cadastro: {...}}
        cadastroData = data.cadastro;
      } else if (data) {
        // Estrutura: {...}
        cadastroData = data;
      }

      // console.log('Dados do cadastro extraídos:', cadastroData);

      if (!cadastroData) {
        console.error('Não foi possível extrair dados do cadastro');
        this.logOut();
        return;
      }

      // Verificar se é um token de admin sendo usado na área do candidato
      if (cadastroData.tipo_usuario === 'admin' || cadastroData.perfil === 'admin') {
        console.error('Token de administrador detectado na área do candidato');
        this.$sweet.showWarning('Você está logado como administrador. Por favor, acesse a área administrativa.');
        this.logOut();
        return;
      }

      this.$store.dispatch('profile/setProfile', { ...cadastroData });

      // Redirecionar apenas se estivermos na rota genérica "area-candidato"
      // e não em uma rota específica dentro da área
      if (this.$route.name === 'area-candidato') {
        this.$router.push({ name: 'area-incricao' }).catch((e) => e);
      }
    } catch (error) {
      console.error('Erro no carregamento inicial:', error);
      this.logOut();
    }
  },

  methods: {
    toggleSubMenu(menuName) {
      this.$set(this.openSubMenus, menuName, !this.openSubMenus[menuName]);
      // Não fechar o menu ao abrir/fechar submenu, apenas ao clicar em um link
    },

    isSubMenuOpen(menuName) {
      return !!this.openSubMenus[menuName];
    },

    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
    },

    closeNavbar() {
      this.isNavbarOpen = false;
    },

    closeNavbarOnMobile() {
      // Fechar o menu sempre que um item for clicado (especialmente em mobile)
      this.isNavbarOpen = false;
      // Também fechar todos os submenus abertos
      this.openSubMenus = {};
    },

    logOut() {
      // Limpar todos os tokens
      localStorage.removeItem(`token-${this.$city}`);
      localStorage.removeItem('admin-token');
      
      // Limpar headers do axios
      delete axios.defaults.headers.common['Authorization'];
      
      // Limpar store
      this.$store.dispatch('profile/setProfile', {});
      
      // Redirecionar para home
      this.$router.push({ name: 'home' });
    },

    isCurrent(route) {
      return this.$route.name === route;
    },
  },

  watch: {
    // Fechar o menu quando a rota mudar
    '$route'() {
      this.closeNavbarOnMobile();
    }
  },

  computed: {
    ...mapGetters({ profile: 'profile/getProfile' }),

    menu() {
      return [
        { 
          isDisabled: false, 
          title: 'Inscrições', 
          name: 'area-incricao',
          icon: 'fas fa-clipboard-list'
        },
        { 
          isDisabled: false, 
          title: 'Solicitar Isenção', 
          name: 'area-solicitar-isencao',
          icon: 'fas fa-hand-holding-heart'
        },
        { 
          isDisabled: false, 
          title: 'Downloads', 
          name: 'area-form',
          icon: 'fas fa-download'
        },
        { 
          isDisabled: false, 
          title: 'Títulos', 
          name: 'area-envios',
          icon: 'fas fa-paper-plane'
        },
        { 
          isDisabled: false, 
          title: 'Recursos', 
          name: 'area-recursos',
          icon: 'fas fa-gavel'
        },
        { 
          isDisabled: false, 
          title: 'Boletos', 
          name: 'area-boleto',
          icon: 'fas fa-file-invoice-dollar'
        },
        { 
          isDisabled: false, 
          title: 'Restituições', 
          name: 'area-restituicao',
          icon: 'fas fa-undo-alt'
        },
        { 
          isDisabled: false, 
          title: 'Cadastro', 
          name: 'area-cadastro',
          icon: 'fas fa-user-edit'
        },
        { 
          isDisabled: false, 
          title: 'Senha', 
          name: 'area-senha',
          icon: 'fas fa-key'
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
/* Área do Candidato */
.area-candidato {
  min-height: 100vh;
  background: #f8f9fa;
}

/* Reset global para numeração */
ol, ul {
  list-style: none !important;
}

ol li::before,
ul li::before {
  display: none !important;
  content: none !important;
}

.nav-item {
  list-style: none !important;
}

.nav-item::marker {
  display: none !important;
}

/* Header */
.area-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-logo {
  width: 60px;
  height: auto;
}

.brand-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 5px;
}

.brand-subtitle {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 0;
}

.header-user {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-avatar {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.user-name {
  font-weight: 600;
  margin-bottom: 2px;
  font-size: 1rem;
}

.user-status {
  font-size: 0.8rem;
  opacity: 0.8;
}

.btn-logout {
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-logout:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: white;
  color: white;
}

/* Navigation */
.area-navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Reset completo para remover numeração */
.area-navbar * {
  counter-reset: none !important;
  counter-increment: none !important;
}

.area-navbar .nav-item {
  counter-reset: none !important;
  counter-increment: none !important;
}

.area-navbar .nav-item::before,
.area-navbar .nav-item::after {
  display: none !important;
  content: none !important;
  counter-reset: none !important;
  counter-increment: none !important;
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
}

.navbar-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.toggle-line {
  width: 25px;
  height: 3px;
  background: #667eea;
  margin: 3px 0;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.navbar-menu {
  flex: 1;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2px;
  justify-content: center;
  flex-wrap: wrap;
}

.nav-item {
  position: relative;
}

/* Remover qualquer numeração automática */
.nav-item::before,
.nav-item::after {
  display: none !important;
  content: none !important;
}

.nav-link::before,
.nav-link::after {
  display: none !important;
  content: none !important;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  color: #495057;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 500;
  position: relative;
  font-size: 0.85rem;
  white-space: nowrap;
}

.nav-link:hover {
  background: #f8f9fa;
  color: #667eea;
  transform: translateY(-1px);
}

.nav-link.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.nav-icon {
  font-size: 0.9rem;
  width: 16px;
  text-align: center;
}

.nav-text {
  font-size: 0.85rem;
}

.nav-badge {
  background: #dc3545;
  color: white;
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: auto;
}

.nav-link-dropdown {
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
}

.nav-arrow {
  margin-left: auto;
  transition: transform 0.3s ease;
}

.nav-item.has-submenu.open .nav-arrow {
  transform: rotate(180deg);
}

/* Submenu */
.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 10px;
  min-width: 250px;
  z-index: 1000;
  list-style: none;
  margin: 0;
  border: 1px solid #e9ecef;
}

.submenu-item {
  margin: 0;
}

.submenu-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  color: #495057;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.submenu-link:hover {
  background: #f8f9fa;
  color: #667eea;
  transform: translateX(5px);
}

.submenu-icon {
  font-size: 0.9rem;
  width: 16px;
  text-align: center;
}

/* Main Content */
.area-main {
  flex: 1;
  padding: 40px 0;
}

.content-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  padding: 30px;
  border: 1px solid #e9ecef;
}

/* Support Section */
.support-section {
  background: #f8f9fa;
  padding: 40px 0;
  margin-top: 40px;
}

.support-content {
  display: flex;
  align-items: center;
  gap: 20px;
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.support-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
}

.support-text h5 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 10px;
}

.support-text p {
  color: #6c757d;
  margin-bottom: 0;
  line-height: 1.6;
}

.support-email {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
}

.support-email:hover {
  text-decoration: underline;
}

/* Responsividade */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .header-brand {
    flex-direction: column;
    gap: 10px;
  }

  .brand-title {
    font-size: 1.5rem;
  }

  .header-user {
    flex-direction: column;
    gap: 15px;
  }

  .navbar-toggle {
    display: flex;
  }

  .navbar-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    animation: fadeIn 0.3s ease;
  }

  .navbar-menu {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    background: white;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.15);
    z-index: 101;
    width: 280px;
    max-width: 85vw;
    transform: translateX(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    overflow-y: auto;
    padding-top: 20px;
  }

  .navbar-menu.is-open {
    transform: translateX(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-list {
    flex-direction: column;
    padding: 20px;
  }

  .nav-link {
    justify-content: flex-start;
    padding: 12px 15px;
    font-size: 0.8rem;
  }

  .nav-icon {
    font-size: 0.8rem;
    width: 14px;
  }

  .submenu {
    position: static;
    box-shadow: none;
    border: none;
    background: #f8f9fa;
    margin-top: 10px;
  }

  .support-content {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .area-main {
    padding: 20px 0;
  }

  .content-section {
    padding: 20px;
  }

  .support-content {
    padding: 20px;
  }
}

/* Animações */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estados de loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>